import DVRControls from './dvr_controls'
export default DVRControls
